import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { VerificationService } from '@sheerid/jslib';
import { redirect } from '../lib/utils/browser';

import { SONIC_REDIRECT_URL } from '../constants'

interface TryAgainButtonComponentProps {
    verificationService: VerificationService;
}

const TryAgainButtonComponent = ({ verificationService }: TryAgainButtonComponentProps) => {

    return (
        <button
            type="button"
            className="sid-btn"
            aria-label="submit"
            onClick={() => {
                redirect(SONIC_REDIRECT_URL);
            }}
            onKeyPress={() => {
                redirect(SONIC_REDIRECT_URL);
            }}
            tabIndex={0}>
                <FormattedHTMLMessage id="goToAppButton" defaultMessage="Open SONIC App" />
        </button>
    );
};

export { TryAgainButtonComponent };
